<template>
    <div class="d-flex flex-column" style="height: 100%; overflow: hidden">
        <base target="_blank" />
        <base target="_parent" />
        <div
            class="d-flex flex-column pa-0 py-0 flex-grow-1 my-1 px-0 mt-0 mb-0 pt-0 containerFull"
            style="height: 100%; overflow: hidden"
            :class="{ paddingRight: true }"
        >
            <div
                class="d-flex flex-column flex-grow-1"
                style="width: 100%; padding: 20px; z-index: 9"
                v-if="addContactInfo"
            >
                <v-sheet class="rounded-lg pa-4 pt-6 pb-3 softShadow agentBox">
                    <h4 class="d-flex flex-row mb-6 mt-2 justify-center">Börja chatta!</h4>
                    <v-divider />
                    <div class="py-2 mt-3 px-3">
                        <p style="font-size: 12px">
                            Fyll i din e-post före chatten startas.
                            <br />
                        </p>
                    </div>
                    <v-divider />
                    <div>
                        <v-form
                            ref="form"
                            v-model="valid"
                            class="mt-6 mb-3"
                            @submit.prevent="addVisitorInfo()"
                            :lazy-validation="lazy"
                        >
                            <v-text-field
                                style="width: 100%; font-size: 16px; align-text: center"
                                :disabled="disableSendField"
                                filled
                                solo
                                flat
                                type="email"
                                background-color="rgb(245,245,245)"
                                label="Din e-postadress"
                                placeholder="Din e-postadress..."
                                autocomplete="off"
                                rows="1"
                                no-resize
                                dense
                                ref="messageRefContact"
                                hide-details="true"
                                class="send-message-textfield rounded my-3"
                                v-model="visitorEmail"
                                :rules="rulesEmail"
                            ></v-text-field>

                            <v-btn
                                :disabled="!valid"
                                class="elevation-0 ml-1 my-3"
                                style="font-size: 12px"
                                :color="cnfg.customer.secondaryColorHex"
                                @click="addVisitorInfo()"
                            >
                                <span :style="{ color: 'white' }">Starta chatten</span>
                            </v-btn>
                        </v-form>
                    </div>
                </v-sheet>
            </div>
            <NoConnection v-if="error == true" />
            <div
                id="chatWindow"
                class="chatWindow d-flex flex-column pa-0 py-1 flex-grow-1 my-1 px-4 mt-0 mb-0 pt-0"
                v-if="!addContactInfo"
                style="height: 0px"
            >
                <div v-for="(x, i) in messageObject" :key="i">
                    <div v-for="(item, i) in x" :key="i">
                        <div
                            class="d-flex flex-column justify-start pa-2 pt-6 pb-0 my-6 rounded-lg agentBox softShadow"
                            style="background-color: rgb(255, 255, 255)"
                            v-if="item.item.From == 'agent-box'"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <div class="d-flex flex-column justify-start">
                                            <h4 class="mb-3">Mer information om återköp!</h4>
                                            <p style="font-size: 12px">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt.
                                            </p>
                                            <v-divider class="mx-1" />
                                            <div class="d-flex flex-row py-3 justify-center" style="">
                                                <v-btn
                                                    :color="primaryColor"
                                                    elevation="0"
                                                    class="mx-1 rounded flex-column flex-grow-1"
                                                    style="font-size: 12px; height: 50px; flex-basis: 0"
                                                >
                                                    Gå till återköp
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <span style="font-size: 12px">{{ item.item.DateTime | moment }}</span>
                            </v-tooltip>
                        </div>

                        <div class="d-flex flex-column justify-start pa-0 ma-0" v-if="item.item.From == 'agent'">
                            <div
                                v-if="i == 0"
                                class="d-flex flex-column py-3 justify-center profileInformation"
                                style="width: 100%; font-size: 10px"
                            >
                                <span class="pb-3" style="color: #aaa">
                                    {{ item.item.DateTime | moment }}
                                </span>
                                <v-divider />
                            </div>

                            <v-tooltip bottom style="max-width: 300px">
                                <template v-slot:activator="{ on }">
                                    <div style="max-width: 300px">
                                        <div class="d-flex" style="align-items: flex-start; max-width: 300px">
                                            <v-avatar
                                                class="d-flexprofileInformation softShadow"
                                                :style="primaryGradientStyle"
                                                size="26"
                                            >
                                                <span
                                                    style="font-weight: bold; font-size: 12px"
                                                    :style="{ color: cnfg.customer.secondaryColorHexHeader }"
                                                >
                                                    {{ firstLetter(item.item.AgentFullName) }}
                                                </span>
                                            </v-avatar>
                                            <div class="d-flex flex-column ml-2" style="align-items: flex-start">
                                                <div
                                                    class="d-flex mb-2"
                                                    style="align-items: flex-start; font-size: 12px; color: #aaa"
                                                >
                                                    {{ item.item.AgentFullName }}
                                                </div>
                                                <div
                                                    v-on="on"
                                                    style="color: white !important"
                                                    class="d-flex flex-column px-3 py-3 chatBoxClient softShadow mb-2 chatBoxMessage"
                                                    :style="{ backgroundColor: cnfg.customer.secondaryColorHex }"
                                                >
                                                    <div
                                                        style="width: 100%; display: inline-block; word-wrap: break-all"
                                                        v-dompurify-html="item.item.Message"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <span style="font-size: 12px">{{ item.item.DateTime | moment }}</span>
                            </v-tooltip>
                        </div>

                        <div class="d-flex flex-column pa-0 ma-0 mb-2" v-else>
                            <div
                                v-if="i == 0"
                                class="d-flex flex-column py-3 justify-center"
                                style="width: 100%; font-size: 10px"
                            >
                                <span class="pb-3" style="color: #aaa">
                                    {{ item.item.DateTime | moment }}
                                </span>
                                <v-divider />
                            </div>
                            <div class="d-flex flex-row justify-end">
                                <v-tooltip bottom style="max-width: 300px">
                                    <template v-slot:activator="{ on }">
                                        <div style="max-width: 300px">
                                            <pre class="d-flex flex-column" style="align-items: flex-start">
                                                <div v-on="on" class="d-flex flex-row px-3 py-3 chatBoxUser softShadow" :style="primaryGradientStyle" >
                                                <div style="width: 100%; display: inline-block; word-wrap: break-all;" v-dompurify-html="item.item.Message"></div></div>

                                            </pre>
                                        </div>
                                    </template>
                                    <span style="font-size: 12px">{{ item.item.DateTime | moment }}</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Show stars -->
                <div
                    class="d-flex flex-column justify-start pa-3 my-3 rounded-lg agentBox mt-6 mb-5 softShadow"
                    style="background-color: rgb(255, 255, 255)"
                    v-if="checkChatStatus && !showStarResponse"
                >
                    <iframe
                        v-if="iframeUrl"
                        :src="iframeObj.url"
                        title="W3Schools Free Online Web Tutorials"
                        width="100%"
                        height="600"
                        frameBorder="0"
                        allowfullscreen="true"
                    ></iframe>
                    <div v-else>
                        <div class="d-flex flex-row justify-center pb-3 pt-1" style="align-items: center">
                            <h4 style="font-weight: 700; font-size: 12px">Chatten är avslutad</h4>
                        </div>
                        <v-divider class="mx-3" />
                        <div class="d-flex flex-column justify-center pt-3">
                            <p class="mb-0 pb-0" style="font-size: 12px">Vad tyckte du om vår service?</p>
                            <v-rating
                                :color="primaryColor"
                                v-model="rating"
                                background-color="grey darken-1"
                                empty-icon="$ratingFull"
                                hover
                            ></v-rating>
                        </div>
                    </div>
                </div>

                <!-- Stars recieved and message to user -->
                <div
                    class="d-flex flex-column justify-start pa-3 my-3 rounded-lg agentBox mt-6 mb-5 softShadow"
                    style="background-color: rgb(255, 255, 255)"
                    v-else-if="showStarResponse"
                >
                    <div>
                        <div class="d-flex flex-row justify-center pb-3 pt-1" style="align-items: center">
                            <h4 style="font-weight: 700; font-size: 12px">Tack för din feedback!</h4>
                        </div>
                        <v-divider class="mx-3" />
                        <div class="d-flex flex-column justify-center pt-3">
                            <p class="mb-0 pb-0" style="font-size: 12px">
                                Vi har tagit emot din feedback och kommer att använda den för att förbättra vår service.
                            </p>
                            <v-rating
                                :color="cnfg.customer.secondaryColorHex"
                                v-model="rating"
                                background-color="grey darken-1"
                                empty-icon="$ratingFull"
                                hover
                                readonly
                            ></v-rating>
                        </div>
                    </div>
                </div>

                <div
                    class="d-flex flex-column justify-center align-center mt-2 mb-0"
                    style="background-color: transparent; font-size: 12px; width: 100%; overflow: hidden"
                    :class="{ showSuggestions_height: showSuggestion }"
                >
                    <div class="d-flex flex-row mt-2" style="position: relative; min-height: 60px">
                        <div v-for="(items, i) in filteredSuggestionList" :key="i">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="ma-2 helpText chatSuggestion px-4 py-0"
                                        outlined
                                        style="
                                            font-size: 10px;
                                            text-transform: none;
                                            letter-spacing: 0px;
                                            border-color: #ccc;
                                        "
                                        @mousedown="sendHelpMessage(items.question)"
                                        v-on="on"
                                        rounded
                                        :class="{
                                            showSuggestions: showSuggestion
                                        }"
                                    >
                                        {{ items.short }}
                                    </v-btn>
                                </template>
                                <span style="font-size: 12px">{{ items.question }}</span>
                            </v-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-show="!addContactInfo"
            style="width: 100%"
            class="d-flex flex-row align-end"
            :class="!addContactInfo ? 'pa-3' : ''"
        >
            <div class="d-flex ma-0 pa-0 flex-grow-1" v-show="!addContactInfo">
                <v-textarea
                    style="width: 100%; font-size: 12px"
                    id="inputText"
                    v-show="!addContactInfo"
                    @focusin="textFieldFocus(true)"
                    @focusout="textFieldFocus(false)"
                    :disabled="disableSendField || error"
                    filled
                    solo
                    background-color="rgb(255,255,255)"
                    placeholder="Ditt meddelande..."
                    label="Ditt meddelande"
                    color="#006eb0"
                    :rows="fieldRows"
                    no-resize
                    dense
                    ref="messageRef"
                    v-model="messageFromVisitor"
                    hide-details="true"
                    class="send-message-textfield mr-1 rounded-lg"
                    @keyup="sendKeyUp"
                    @keydown="sendKeyDown"
                    :class="{ bottomSection: textFieldIsFocused }"
                ></v-textarea>
            </div>
            <div class="d-flex flex-row" v-show="!addContactInfo">
                <!-- Emoji-picker -->
                <v-menu top left v-show="!addContactInfo">
                    <template v-slot:activator="{ on, attrs }" v-show="!addContactInfo">
                        <v-btn
                            v-show="!addContactInfo"
                            color="black"
                            class="ml-1 mb-1"
                            fab
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            style="border-color: #ccc"
                        >
                            <span style="font-size: 24px; position: relative" class="pb-1" v-show="!addContactInfo">
                                <v-icon>mdi-emoticon</v-icon>
                            </span>
                        </v-btn>
                    </template>

                    <v-list class="pa-0" style="width: 280px !important" v-show="!addContactInfo">
                        <VEmojiPicker
                            v-show="!addContactInfo"
                            @select="selectEmoji"
                            :showSearch="false"
                            :showCategories="false"
                            :emojiSize="28"
                            :emojisByRow="5"
                            style="width: 100%"
                        />
                    </v-list>
                </v-menu>

                <v-btn color="black" class="ml-1 mb-1" fab x-small outlined style="border-color: #ccc; display: none">
                    <v-icon>mdi-paperclip</v-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '../api/config';
    import _ from 'lodash';
    import ItemTemplate from './ItemTemplate.vue';
    import { VEmojiPicker } from 'v-emoji-picker';
    import SecureLS from 'secure-ls';

    export default {
        name: 'app',
        props: ['user', 'booking', 'primaryColor', 'secondaryColor', 'primaryGradient', 'suggestion', 'openChat'],

        data() {
            return {
                cnfg: config,
                item: {
                    id: 9,
                    name: 'Lion',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'
                },
                ls: new SecureLS({ encodingType: 'aes' }),
                showStarResponse: false,
                rating: 0,
                items: [],
                template: ItemTemplate,
                fieldRows: 1,
                valid: false,
                lazy: false,
                userObject: '',
                messageFromVisitor: '',
                visitorId: localStorage.getItem('visitorId'),
                messageObject: [],
                dialog: false,
                addContactInfo: true,
                visitorEmail: '',
                visitorClientNumber: '',
                visitorInfo: {},
                rulesEmail: [
                    (v) => !!v || 'Du måste skriva en e-post',
                    (v) => /.+@.+\..+/.test(v) || 'E-posten är inte korrekt.'
                ],
                rulesClientNumber: [
                    (v) => v.length >= 4 || 'Numret måste vara minst 4 tecken',
                    (v) => !!v || 'Du måste ange ett nummer'
                ],
                disableSendField: false,
                connectionUp: 'idle',
                error: false,
                screenSharing: false,
                shiftPressed: false,
                chatClosed: false,
                textFieldIsFocused: false,
                showSuggestion: false,

                primaryStyle: {
                    backgroundColor: this.primaryColor,
                    color: this.secondaryColor
                },
                primaryColorStyle: {
                    color: this.secondaryColor
                },

                primaryGradientStyle: {
                    backgroundColor: this.primaryGradient,
                    background: this.primaryGradient,
                    color: this.secondaryColor
                },

                suggestionList: [],
                rand: null,
                iframeObj: {
                    active: false,
                    url: ''
                },
                ableToOpenChat: false
            };
        },
        filters: {
            moment: function (date) {
                let d = new Date(date);
                let TODAY = new Date();

                if (d.getDate() === TODAY.getDate()) {
                    return 'Idag ' + d.toLocaleString().substr(11, 5);
                } else {
                    return d.toLocaleString().substr(0, 10);
                }
            }
        },
        components: {
            VEmojiPicker,
            NoConnection: () => import('./Small/NoConnection.vue')
        },
        computed: {
            iframeUrl() {
                return this.iframeObj.active;
            },
            filteredSuggestionList() {
                //if input is empty, display none.
                return;
            },
            agentFullName() {
                return this.$props.user.name;
            },
            chatIsOpen() {
                return this.$props.openChat;
            },
            agentProfilePicture() {
                return this.$props.user.profileImageUrl;
            },
            bookingObject_() {
                return this.$props.booking;
            },
            checkChatStatus() {
                return this.chatClosed;
            }
        },
        watch: {
            rating(value) {
                this.saveStars(value);
            },

            messageFromVisitor(value) {
                this.onWriting(value);
            },
            connectionUp(value) {
                console.log('connectionUp', this.chatClosed);
                if (this.chatClosed) {
                    console.log('Chat is closed, do not warn about the connection');
                    return;
                }

                if (value == 'error') {
                    this.error = true;
                } else {
                    console.log('Info -> Connection is back again, try to restart the chat');
                    this.error = false;
                    this.startTheChat();
                }
            }
        },
        sockets: {
            error: function (data) {
                console.warn('Error -> ', data);
                alert('Något har gått fel, var vänlig försök igen senare. Felkod: #987261 mer info -> ', data);
                this.$store.dispatch('goBack');
            },
            serviceRateRes: function (data) {
                if (data != undefined && this.connectionUp == 'idle') {
                    // this.showStarResponse = true;
                    this.scrollToBottom();
                }
            },
            blockedToManyGeneralCalls: async function (data) {
                console.log('SpamTitan, you are blocked ', data);
                alert('You are blocked because of spam, please contact the support');
                this.closeChat();
                this.blocked();
            },
            blockedToManyChats: async function (data) {
                console.log('You have created to many chats, please wait a few minutes and try again');
                alert('You have created to many chats, please wait a few minutes and try again');
                this.closeChat();
                this.blocked();
            },
            connect: function () {
                this.connectionUp = 'idle';
            },
            connect_failed: function () {
                this.connectionUp = 'error';
            },
            disconnecting: function () {
                this.$socket.emit('disconnectingChat', {
                    visitorId: this.visitorId,
                    agentUserId: this.$props.user.userId,
                    rand: this.rand
                });
                this.connectionUp = 'error';
            },
            disconnect: function () {
                this.connectionUp = 'error';
            },
            emitToVisitor: function (data) {
                console.log('Set value of localStorage rand --- = ', data);
                //localStorage.setItem('rand', data);
                this.ls.set('rand', data);
                this.rand = data;
            },
            leaveSession: function (data) {
                this.closeChat(data);
            },
            chatIsNowClosed: async function (data) {
                console.log('Emit -> chatIsNowClosed', data);
                this.chatClosed = true;
                if (data.ExternalSurvey) {
                    this.iframeObj.active = true;
                    this.iframeObj.url = data.ExternalSurveyUrl.replace('{{caseId}}', this.rand);
                } else {
                    this.iframeObj.active = false;
                    this.iframeObj.url = '';
                }

                // Clos the chat and scroll to bottom of view.
                this.closeChat(data);
                this.scrollToBottom();
            },
            incrementMessage: function (data) {
                this.mangleConversation([data]);
            },
            inititalConversation: function (data) {
                console.log('Info -> Get initial conversation');
                let objDiv = document.getElementById('chatWindow');
                setTimeout(() => {
                    objDiv.scrollTop = objDiv.scrollHeight - 50;
                }, 50);

                this.mangleConversation(data, true);
            }
        },
        destroyed() {
            document.removeEventListener('visibilitychange', this.handleVisibility);
        },
        mounted() {
            document.addEventListener('visibilitychange', this.handleVisibility, false);
            this.$refs.messageRef.$refs.input.setAttribute('enterkeyhint', 'send');
            this.$refs.messageRefContact.$refs.input.setAttribute('enterkeyhint', 'send');
            let tempRand = null;
            try {
                tempRand = this.ls.get('rand');
            } catch (error) {
                tempRand = null;
                console.log('No chat is active');
            }

            this.rand = tempRand;

            if (localStorage.getItem('visitorInfo') !== null) {
                this.visitorInfo = {
                    visitorEmail: JSON.parse(localStorage.getItem('visitorInfo')).visitorEmail,
                    visitorClientNumber: JSON.parse(localStorage.getItem('visitorInfo')).visitorClientNumber,
                    visitorId: this.visitorId
                };

                console.log('Info -> VisitiorInfoObject exists -> ', this.visitorInfo);

                this.visitorEmail = this.visitorInfo.visitorEmail;

                if (this.rand) {
                    console.log('startChat', this.chatIsOpen);
                    this.addContactInfo = false;
                    this.startTheChat();
                }
            } else {
                this.addContactInfo = true;
                //this.$emit('chatOpen'); // Check if chat is open..?
            }
        },
        methods: {
            blocked() {
                this.ls.removeAll();
                this.rand = null;
                this.chatClosed = true;
                localStorage.clear();
                window.location.reload();
                console.warn('This user is blocked!');
            },
            handleVisibility() {
                if (this.chatClosed === true) {
                    return;
                }

                if (document.visibilityState === 'visible') {
                    console.log('Info -> Tab is visible');
                    if (this.rand) {
                        this.startTheChat();
                    }
                } else {
                    console.log('Info -> Tab is not visible');
                }
            },
            closeChat(data) {
        
                if (this.chatClosed && data == null) {
                    console.log('Chat is already closed go back');
                    this.$store.dispatch('goBack');
                    return;
                }

                this.chatClosed = true;

                if (data?.MoreInfo?.code === 403) {
                    console.log('Info -> Chat is already closed dont emit anything');
                } else {
                    // Leaving chat
                    this.rand = this.ls.get('rand');
                    this.$socket.emit('chatClosed', {
                        visitorId: this.visitorId,
                        agentUserId: this.$props.user.userId,
                        rand: this.rand
                    });
                }

                this.rand = null;
                //localStorage.removeItem('rand');
                this.ls.remove('rand');
                this.disableSendField = true;
                this.showStarResponse = false;

                // Delay disconnect so we can show the chat is closed message
                setTimeout(() => {
                    let self = this;
                    console.log('Disconnect socket.');
                    self.$socket.disconnect();
                }, 1000);
            },
            mangleConversation(data, init = false) {
                const newMessageObject = [];
                const oldMessageObject = structuredClone(this.messageObject);
                const items = init ? [] : [].concat(...Object.values(oldMessageObject));
                this.messageObject = [...items, ...data];
                this.messageObject.forEach((item) => {

                    // Get integer timestamp with seconds and milliseconds set to 0 (to group by minutes

                    if(item.Message) { // for some reason item.Message is undefined sometimes
                        let urlRegex =
                            /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/gm;
                        // use the above regex to replace all urls with <a> tags
                        let color = item.From == 'agent' ? 'white' : '#11448f'
                        item.Message = item.Message.replaceAll(urlRegex, function (url) {
                            if (!url.match('^https?://') && !url.includes('@')) {
                                url = 'https://' + url;
                            }
                            return '<a style="color:' + color + '" href="' + url + '">' + url + '</a>';
                        });
                    }

                    let time = new Date(item.DateTime);
                    time.setSeconds(0);
                    time.setMilliseconds(0);
                    let createdAtMinutes = time.getTime();
                    if (Object.keys(item).includes('item')) {
                        newMessageObject.push(item);
                    } else {
                        newMessageObject.push({
                            groupTime: createdAtMinutes,
                            user: item.AgentUserId,
                            item: item
                        });
                    }
                });
                this.messageObject = _.groupBy(newMessageObject, 'groupTime', 'user');
                this.scrollToBottom();
            },
            saveConversation() {
                const payload = {
                    rand: '',
                    email: '',
                    visitorId: '',
                    dateTime: new Date()
                };
                this.$socket.emit('saveConversation', payload);
            },
            saveStars(value) {
                const payload = {
                    stars: value, // 0-5
                    rand: this.rand,
                    visitorId: this.visitorId,
                    customerEmail: 'epost' || '',
                    dateTime: new Date()
                };
                this.$socket.emit('serviceRate', payload);

                // Set rand = null and remove the item from localStorage
                this.rand = null;
                this.ls.remove('rand');
            },
            selectEmoji(emoji) {
                if (this.messageFromVisitor == null) {
                    this.messageFromVisitor = emoji.data;
                } else {
                    this.messageFromVisitor += emoji.data;
                }
                document.getElementById('inputText').focus();
            },
            scrollToBottom() {
                let objDiv = document.getElementById('chatWindow');
                setTimeout(() => {
                    objDiv.scrollTop = objDiv.scrollHeight - 50;
                }, 50);
            },
            textFieldFocus(value) {
                //fix animation when creating the object
                this.textFieldIsFocused = value;
                if (this.textFieldIsFocused == true) {
                    this.fieldRows = 3;
                } else {
                    this.fieldRows = 1;
                }
            },
            getLabel(item) {
                return item.name;
            },
            updateItems(text) {
                yourGetItemsMethod(text).then((response) => {
                    this.items = response;
                });
            },
            checkAgentFirst: function (array, i) {
                array.forEach((item, x) => {
                    if (item.user != '0' && x == i) {
                        return true;
                    } else {
                        return false;
                    }
                });
            },
            //return first letter of agent for icon
            firstLetter(agent) {
                return agent?.charAt(0).toUpperCase() || '';
            },
            clientWritingMessage: function (data) {
                clearInterval(this.interval);
                if (data > 0) {
                    this.agentIsWriting = true;
                    let self = this;
                    this.interval = setInterval(function () {
                        self.agentIsWriting = false;
                    }, 3000);
                    // this.scrollToEnd();
                } else {
                    this.agentIsWriting = false;
                }
            },
            onWriting(data) {
                this.$socket.emit('clientWriting', {
                    message: data,
                    rand: this.rand
                });
            },
            scroll() {
                window.scrollTo(0, 0);
            },
            startTheChat() {
                console.log('Info -> Start chat?', this.rand);
                this.$socket.connect();

                const metaData = {
                    parentUrl: (window.location != window.parent.location)? document.referrer: document.location.href || 'UNKNOWN',
                    language: navigator.language || navigator.userLanguage || 'UNKNOWN',
                    userAgent: navigator.userAgent || 'UNKNOWN',
                }

                const landingNumber = new URLSearchParams(window.location.search).get('customerid')
                console.log("[Debug] -> landingNumber: ", landingNumber , new Date())
  
                if (!this.rand) {
                    // If no chat exists do chatOpen to create a new
                    console.log('Info chatOpen ');
                    this.$socket.emit('chatOpen', {
                        recipient: config.customer.relationId,
                        landingNumber: landingNumber || 'UNKNOWN',
                        visitorId: this.visitorId,
                        agentUserId: 0,
                        fromAgent: false,
                        visitorInfo: this.visitorInfo,
                        metaData
                    });
                } else {
                    console.log('Continue chat');
                    // If chat exists do continueChat to get the existing
                    this.$socket.emit('continueChat', {
                        visitorId: this.visitorId,
                        agentUserId: 0,
                        fromAgent: false,
                        visitorInfo: this.visitorInfo,
                        rand: this.rand,
                        metaData
                    });
                }
            },
            addVisitorInfo() {
                if (event.keyCode === 13 && this.shiftPressed === false) {
                    event.preventDefault();
                }
                console.log('Info -> Add visitor info & start chat');
                //regex to validate email
                let emailRegex =
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                // validate email with regex

                if (!this.visitorEmail) return;
                if (!emailRegex.test(this.visitorEmail)) return;

                this.visitorInfo = {
                    visitorEmail: this.visitorEmail,
                    visitorClientNumber: this.visitorClientNumber,
                    visitorId: this.visitorId
                };
                localStorage.setItem('visitorInfo', JSON.stringify(this.visitorInfo));
                this.addContactInfo = false;

                this.ableToOpenChat = true;
                this.startTheChat();
            },
            sendKeyUp() {
                if (event.keyCode === 16) {
                    this.shiftPressed = false;
                } else if (this.shiftPressed && event.keyCode == 13) {
                    // new line
                    this.shiftPressed = false;
                }
            },
            sendKeyDown() {
                if (event.keyCode === 16) {
                    this.shiftPressed = true;
                } else if (event.keyCode === 13 && this.shiftPressed === false) {
                    event.preventDefault();
                    this.sendMessage();
                }
            },
            sendHelpMessage(message) {
                const tempInteractionObject = {
                    visitorId: this.visitorId,
                    agentFullName: this.agentFullName,
                    agentUserId: this.$props.user.userId,
                    message: message,
                    rand: this.rand,
                    from: 'client',
                    clientEmail: this.visitorInfo.visitorEmail
                };
                this.$socket.emit('sendMessage', tempInteractionObject);
                // After sending clear the input field and the string
                this.$refs.messageRef.clearableCallback();
                this.scrollToBottom();
                this.showSuggestion = false;
            },
            sendMessage() {
                // Check if message is empty from customer
                let tempMsgText = this.messageFromVisitor?.replaceAll('\\s+', '');

                if (tempMsgText?.length == 0 || tempMsgText?.length == null) {
                    alert('Du måste skriva något');
                    return;
                }
                console.log("this.visitorInfo.visitorEmail,",this.visitorInfo.visitorEmail)
                // Create the object to send to server
                const tempInteractionObject = {
                    visitorId: this.visitorId,
                    agentFullName: this.AgentFullName,
                    agentUserId: this.$props.user.userId,
                    message: this.messageFromVisitor,
                    rand: this.rand,
                    from: this.visitorInfo.visitorEmail,
                    clientEmail: this.visitorInfo.visitorEmail
                };

                if (this.rand === null) {
                    alert('Något har blivit fel, var vänlig starta om chattfönstret. Felkod #98621');
                    return;
                }
                this.$socket.emit('sendMessage', tempInteractionObject);
                // After sending clear the input field and the string
                this.$refs.messageRef.clearableCallback();
                this.scroll();
            }
        }
    };
</script>

<style scoped>
    .v-application div.v-text-field--outlined {
        color: black !important;
    }

    .v-text-field--outlined.v-input--is-focused fieldset,
    .v-text-field--outlined.v-input--has-state fieldset {
        border-color: transparent !important;
    }

    :deep .v-label {
        font-size: 12px !important;
    }

    :deep .v-label--active {
        font-size: 12px !important;
        font-weight: bold;
    }

    @media screen and (-webkit-min-device-pixel-ratio: 0) {
        select,
        textarea,
        input {
            font-size: 16px !important;
        }

        :deep .chatBoxMessage p:last-child {
            margin-bottom: 0px !important;
        }

        .v-textarea {
            font-size: 16px !important;
        }
    }

    /* this would be nice if you can add a function that pushes up the textarea & send buttn when the mobile keyboard is up  */

    /* @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .chatWindow {
      height: 75vh;
    }
} */

    :deep .chatBoxMessage p:last-child {
        margin-bottom: 0px !important;
    }
</style>
